module.exports = __webpack_public_path__ + "static/media/geocaching.a2a3f6ab.svg";